import { UserProfile } from "../user";

export class MailAnalysisState {
    public userProfile: UserProfile | null = null;

    public currentMonthEmailCount: number | null = null;

    public monthlyAnalysedMailsLimit: number | null = null;
}
